import type { PaginationType } from '../types/Pagination.types';
import z from 'zod';
import { PaginationParamsSchema } from '../types/Pagination.types';

export const PlayerStreakDtoSchema = z.object({
  userId: z.string().uuid(),
  currentStreak: z.number(),
  isCountedToday: z.boolean(),
  lastCountedAt: z.string().nullable(),
}).describe('PlayerStreakDto');

export const StreakXpAwardDtoSchema = z.object({
  id: z.string().uuid(),
  dayFrom: z.number(),
  dayTo: z.number().nullable(),
  xpAmount: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
}).describe('StreakXpAwardDto');

export const StreakXpAwardFiltersSchema = z.object({
  dayFrom: z.number().optional(),
  dayTo: z.number().optional(),
  xpAmount: z.number().optional(),
});

export const StreakXpAwardParamsSchema = PaginationParamsSchema(StreakXpAwardFiltersSchema);

export type PlayerStreakDto = z.infer<typeof PlayerStreakDtoSchema>;
export type StreakXpAwardDto = z.infer<typeof StreakXpAwardDtoSchema>;
export type StreakXpAwardParams = z.infer<typeof StreakXpAwardParamsSchema>;
export type StreakXpAwardListDto = PaginationType<StreakXpAwardDto>;
